export default "__VITE_ASSET__DuX4iiGk__"